import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { connect, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { LeftOutlined, FolderOpenOutlined, EyeOutlined } from '@ant-design/icons';

//ANT DESIGN IMPORTS
import {
    Typography,
    Card,
    Table,
    Row,
    Spin,
    Col,
    Form,
    Input,
    Button,
    Descriptions,
    Modal,
    Space,
    Divider,
    Tooltip
} from "antd";


//PROJECT IMPORTS
import TopContent from "../../../../../../components/layouts/TopContent";
import appStatic from "../../../../../../config/appStatic";
import { BOM } from "../../../../../../services/definedMethod";
import cnt from "../../../../../../services/definedConstant";
import MainLayout from "../../../../../../components/layouts/MainLayout";
import { apiConfig, labelConfig, staticConfig } from "../../../../customer.config";


const { Text, Title } = Typography;


const DetailJournalEntry = (props) => {
    //DECLARED VARIABLES
    const { userData, rightBtn } = props;
    const { session } = userData;
    const { monthList } = appStatic
    const navigate = useNavigate();
    const { state } = useLocation();
    const [useForm] = Form.useForm();
    const [journalEntryDetail, setJournalEntryDetail] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [journalEntryList, setJournalEntryList] = useState([]);
    const [originalList, setOriginalList] = useState([]);
    const [tableCount, setTableCount] = useState("10");

    const columns = [
        {
            title: "Entry ID",
            dataIndex: "entryId",
        },

        {
            title: "Type",
            dataIndex: "type",
        },
        {
            title: "Account",
            dataIndex: "account",
        },
        {
            title: "Debit",
            dataIndex: "debit",
        },
        {
            title: "Cedit",
            dataIndex: "credit",
        },
        {
            title: "Actions",
            render: (_, record) => (
                <>
                    <DetailJournalEntryModal
                        state={state}
                        userData={userData}
                        recordObj={record}
                    />
                </>
            ),
        },
    ];

    const items = [
        {
            label: labelConfig.branch,
            children: journalEntryDetail.officeName
        },
        {
            label: labelConfig.transactionDate,
            children: journalEntryDetail?.transactionDate
                ? (`${journalEntryDetail?.transactionDate[2]} ${monthList[journalEntryDetail?.transactionDate[1] - 1]} ${journalEntryDetail?.transactionDate[0]}`)
                : "-"
        },
        {
            label: labelConfig.createdBy,
            children: journalEntryDetail.createdByUserName,
        },
        {
            label: labelConfig.createdOn,
            children: journalEntryDetail?.createdDate
                ? (`${journalEntryDetail?.createdDate[2]} ${monthList[journalEntryDetail?.createdDate[1] - 1]} ${journalEntryDetail?.createdDate[0]}`)
                : "-"
        },
    ];

    useEffect(() => {
        getDetailById(state);
    }, []);

    const getDetailById = (params) => {
        setIsLoading(true);

        const url = `${apiConfig.detailJournalEntry}=${params.transactionId}`;

        let body = {
            session,
        };

        /** FETCH ROLE */
        BOM.FetchReqAction(body, url, (err, res) => {
            if (err) {
                BOM.AlertMsg(cnt.DANGER, err.errors[0].defaultUserMessage);
            } else {
                const objDetail = res.pageItems;
                setJournalEntryDetail(objDetail[0]);

                let tempArray = [];

                objDetail.forEach((element) => {
                    tempArray.push({
                        key: element?.id,
                        entryId: element?.id
                            ? element?.id
                            : "No ID",
                        branch: element?.officeName
                            ? element?.officeName
                            : "No Branch",
                        transactionDate: element?.transactionDate ? element?.transactionDate  : "No Transaction Date",
                        transactionId: element?.transactionId ? element?.transactionId : "No Transaction ID",
                        type: element?.glAccountType?.value ? element?.glAccountType?.value : "No Type",
                        createdBy: element?.createdByUserName ? element?.createdByUserName : "No User Name",
                        createdDate: element?.createdDate ? element?.createdDate : "No Created Date",
                        account: element?.glAccountName ? (`${element?.glAccountName} (${element?.glAccountCode})`) : "No short local currency",
                        debit: element?.entryType?.value?.toLowerCase() === "debit" ? element?.amount : "-",
                        credit: element?.entryType?.value?.toLowerCase() === "credit" ? element?.amount : "-",
                    });
                });


                //Display only active records list on the table; this will change after switching from authorized to disabled and vice versa.
                setJournalEntryList(tempArray);

                //keep the orginal data to use after gList is modified when change from autorise to disable
                setOriginalList(tempArray);

                //STOP LOAD
                setIsLoading(false);

                setIsLoading(false);
            }
        });
    };

    function backOnClick() {
        navigate("/search-journal-entries", { state: { id: state.id } });
      }

    return (
        <MainLayout
            isEnableRightSidebar={true}
        >
            {/* PART 1  IMPORT TOP CONTENT*/}
            <TopContent
                pageTitle={labelConfig.detailJournalEntry}
                pageItems={staticConfig.detailJournalEntryBreadcrumbItems}
            />

            <Spin spinning={isLoading} size="large">
                {/* PART 2 DISPLAY CONTENT */}
                <Card
                    style={{
                        marginBottom: "3%",
                        boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
                        borderRadius: 20,
                    }}

                    title={
                        <Row
                          style={{
                            alignContent: "center",
                            //   width: "8%",
                          }}
                        >
                          <Button
                            icon={<LeftOutlined />}
                            type="text"
                            style={{
                              marginTop: "auto",
                              marginBottom: "auto",
                            }}
                            onClick={backOnClick}
                          >
                            <Text
                              style={{
                                marginTop: "auto",
                                marginBottom: "auto",
                                fontSize: 15,
                              }}
                            >
                              Back
                            </Text>
                          </Button>
                        </Row>
                      }                >

                    <Card
                        style={{
                            marginBottom: "2%",
                            boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
                        }}
                    >

                        <Form
                            form={useForm}
                            layout="vertical"
                            style={{ paddingTop: 20, marginBottom: 50 }}
                        >
                            <Descriptions
                                bordered
                                column={{
                                    xs: 1,
                                    sm: 2,
                                    md: 2,
                                    lg: 2,
                                    xl: 2,
                                    xxl: 2,
                                }}
                                style={{ marginTop: 10, marginBottom: 20 }}
                                items={items}
                            />

                        </Form>

                        <Table
                            columns={columns}
                            dataSource={journalEntryList}
                            bordered
                            pagination={{
                                position: "bottomCentre",
                                pageSize: tableCount,
                            }}
                        />
                    </Card>

                </Card>
             
            </Spin>
        </MainLayout>
    );
};

const mapStateToProps = (state) => ({
    userData: state.AuthenticationData.userData,
    rightBtn: state.RightSideBtn,
});
const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(DetailJournalEntry);


const DetailJournalEntryModal = (props) => {
    const { userData, recordObj, state } = props;

    const { session } = userData;

    const [useForm] = Form.useForm();
    const [inputField, setInputField] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const getDetailById = (params) => {
        setIsLoading(true);

        const url = `${apiConfig.detailJournalEntry}=${params.transactionId}`;

        let body = {
            session,
        };

        /** FETCH ROLE */
        BOM.FetchReqAction(body, url, (err, res) => {
            if (err) {
                BOM.AlertMsg(cnt.DANGER, err?.errors[0].defaultUserMessage);
                setIsLoading(false);
            } else {
                const objDetail = res;
                // setJournalEntryDetail(objDetail)

                setInputField([
                    {
                        name: labelConfig.office,
                        value: recordObj?.branch,
                        type: "general",
                    },
                    {
                        name: labelConfig.entryId,
                        value: recordObj?.entryId,
                        type: "general",
                    },
                    {
                        name: labelConfig.transactionId,
                        value: recordObj?.transactionId,
                        type: "general",
                    },

                    {
                        name: labelConfig.transactionDate,
                        value: BOM.FormatArrayDate(recordObj?.transactionDate),
                        type: "general",
                    },
                    {
                        name: labelConfig.type,
                        value: recordObj.type,
                        type: "general",
                    },

                    {
                        name: labelConfig.account,
                        value: recordObj?.account,
                        type: "general",
                    },
                    {
                        name: labelConfig.debit,
                        value: recordObj?.debit,
                        type: "general",
                    },
                    {
                        name: labelConfig.paymentTypeId,
                        value: recordObj?.paymentDetailData?.paymentType?.name,
                        type: "payment",
                    },

                    {
                        name: labelConfig.accountNo,
                        value: recordObj?.paymentDetailData?.paymentType?.name,
                        type: "payment",
                    },

                    {
                        name: labelConfig.chequeNo,
                        value: recordObj?.paymentDetailData?.paymentType?.name,
                        type: "payment",
                    },

                    {
                        name: labelConfig.routingCode,
                        value: recordObj?.paymentDetailData?.paymentType?.name,
                        type: "payment",
                    },

                    {
                        name: labelConfig.receiptNo,
                        value: objDetail?.paymentDetailData?.paymentType?.name,
                        type: "payment",
                    },
                    {
                        name: labelConfig.bankNo,
                        value: objDetail?.paymentDetailData?.paymentType?.name,
                        type: "payment",
                    },
                    {
                        name: labelConfig.createdBy,
                        value: recordObj?.createdBy,
                        type: "payment",
                    },
                    {
                        name: labelConfig.createdOn,
                        value: BOM.FormatArrayDate(recordObj?.createdDate),
                        type: "payment",
                    },

                ]);

                setIsLoading(false);
            }
        });
    };

    const showModal = () => {
        setIsModalOpen(true);
        getDetailById(state);
    };

    const handleOk = () => {
        setIsModalOpen(false);
    };
    const handleCancel = () => {
        setIsModalOpen(false);
    };


    return (
        <>
            <Tooltip title={`View Detail`}>
                <Button
                    type="primary"
                    icon={<FolderOpenOutlined />}
                    onClick={showModal}
                    shape="round"
                    size="small"
                    className="of-primaryBtnColor"
                />
            </Tooltip>
            <Modal
                title="Journal Entry Detail"
                centered
                open={isModalOpen}
                onOk={handleOk}
                onCancel={handleCancel}
                width={800}
                style={{
                    height: 600,
                    overflow: "auto",
                }}
            >
                <Spin spinning={isLoading} tip="Loading..." size="large">
                    <Form layout="vertical" form={useForm}>
                        <Row>
                            <Divider orientation="left">{labelConfig.generalInfo}</Divider>
                            {inputField.map(
                                (item, index) =>
                                    item?.type?.toLowerCase() === "general" && (
                                        <Col key={index} span={8} style={{ padding: "0px 8px" }}>
                                            <Form.Item label={item.name}>
                                                <Input
                                                    disabled
                                                    value={item.value}
                                                    className="of-bold-disable-input"
                                                />
                                            </Form.Item>
                                        </Col>
                                    )
                            )}
                        </Row>
                        <Row>
                            <Divider orientation="left">
                                {labelConfig.paymentInformation}
                            </Divider>
                            {inputField.map(
                                (item, index) =>
                                    item?.type?.toLowerCase() === "payment" && (
                                        <Col key={index} span={8} style={{ padding: "0px 8px" }}>
                                            <Form.Item label={item.name}>
                                                <Input
                                                    disabled
                                                    value={item.value}
                                                    className="of-bold-disable-input"
                                                />
                                            </Form.Item>
                                        </Col>)
                            )}
                        </Row>
                    </Form>
                </Spin>
            </Modal>
        </>
    );
}